import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { useTrackStorefrontImpression } from '@hooks/useTrackStorefrontImpression';
import { useAppSelector } from '@redux/hooks';
import { selectIsMobile } from '@redux/viewport/selectors';
import { Link } from '@tkww/orion-web-ds-action';
import { TextBody } from '@tkww/orion-web-ds-text';
import React, { useCallback } from 'react';
import AnalyticsConstants from '../../../../../constants/analytics';
import VendorAnalytics from '../../../../decorators/vendorAnalytics';
import { PeaceOfMindBadge } from './PeaceOfMindBadge';
import Styles from './PeaceOfMindCallout.scss';

const PEACE_OF_MIND_LEARN_MORE_URL = 'https://www.theknot.com/peace-of-mind';

export const PeaceOfMindCallout = () => {
	const trackingRef = useTrackStorefrontImpression('Peace of Mind callout');
	const vendor = useAppSelector((state) => state.vendor.vendor);
	const memberId = useAppSelector((state) => state.membership.member?.id) ?? '';
	const isMobile = useAppSelector(selectIsMobile);
	const { track } = useAnalyticsContext();

	const handleOnClick = useCallback(() => {
		if (!vendor) return;
		const vendorAnalytics = new VendorAnalytics(vendor);
		track({
			event: AnalyticsConstants.CLICK_THROUGH_TO_WEBSITE,
			properties: {
				destination: 'Peace of Mind',
				memberId,
				...vendorAnalytics.baseEventProps(),
			},
		});
	}, [vendor, memberId, track]);

	return (
		<div className={Styles.container} ref={trackingRef}>
			<div>
				<PeaceOfMindBadge />
			</div>
			<div className={Styles.body}>
				<TextBody color="info" size={isMobile ? 'sm' : 'md'} bold>
					The Knot Peace of Mind
				</TextBody>
				<TextBody size={isMobile ? 'xs' : 'sm'}>
					Book with confidence knowing we're in your corner. If plans change,
					The Knot Peace of Mind helps with rebooking support and cost
					assistance so you can stay focused on the moments that matter most.
				</TextBody>
				<Link
					href={PEACE_OF_MIND_LEARN_MORE_URL}
					styleType="secondary"
					className={Styles.link}
					onClick={handleOnClick}
					target="_blank"
				>
					Learn more
				</Link>
			</div>
		</div>
	);
};
